<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.givenName"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" v-if="member.middleName"
          
          id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.middleName"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.surName"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"            id="companyName"
            
            
            disabled="true"
            :value="member.idType.toLowerCase()"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.idNumber"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.nationality"
            required>
        </input>
      </div>
    </div>
    <div class="col-span-12">
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.email"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.phoneNumber"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"            id="companyName"
            
            
            disabled="true"
            :value="member.sex.toLowerCase()"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="dateFormat(member.dateOfBirth)"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.occupation"
            required>
        </input>
      </div>
    </div>
    <div class="col-span-12">
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            
            
            disabled="true"
            :value="address.district.name"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            
            
            disabled="true"
            :value="address.region.name"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            
            
            disabled="true"
            :value="address.subcounty.name"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            
            
            disabled="true"
            :value="address.parish.name"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            
            
            disabled="true"
            :value="address.village.name"
            required>
        </input>
      </div>
    </div>
    <div class="col-span-12">
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.postalAddress"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.street"
            required>
        </input>
      </div>
      <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"            id="companyName"
            
            
            disabled="true"
            :value="member.plot"
            required>
        </input>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { dateFormat } from "@/commons/composables/utilities";
import { useToast } from "@/composables";
import { api } from "@/app/services/api.service";

const props = defineProps<{ member: any }>();

const { errorToast } = useToast();

const address = ref<any>(null);

onMounted(() => {
  fetchAddressByVillageId(props.member.villageId);
});

const fetchAddressByVillageId = async (id: string) => {
  api().get("/configuration/address/full-path?villageId=" + id)
    .then(response => {
      address.value = response.data.data;
    }).catch(error => {
    errorToast("Error", error.data);
  });
}
</script>

